import React, { PropsWithoutRef, JSXElementConstructor } from 'react';

export function withRef<T>(Component: JSXElementConstructor<T>) {
  return React.forwardRef<unknown, PropsWithoutRef<T>>((props, ref) => {
    return <Component innerRef={ref} refForward={ref} {...(props as T)} />;
  });
}
